import { render, staticRenderFns } from "./ModalBuscaPlacaDetran.vue?vue&type=template&id=1a01bfa2"
import script from "./ModalBuscaPlacaDetran.vue?vue&type=script&lang=js"
export * from "./ModalBuscaPlacaDetran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports